import React, { useEffect, useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import Sidebar from "../Sidebar/Sidebar";
import ContentSection from "./ContentSection";
import { useLocation, useNavigate } from "react-router-dom";
interface LayoutProps {
    isSidebarOpen: boolean;
    toggleSidebar: () => void;
    updateIsReadStatus: boolean;
    setUpdateIsReadStatus: (value: boolean) => void;
}
const Layout: React.FC<LayoutProps> = ({
    isSidebarOpen,
    toggleSidebar,
    updateIsReadStatus,
    setUpdateIsReadStatus
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = React.useState("");
    useEffect(() => {
        const pageName = location.pathname.replace("/layout/", "");
        setActivePage(pageName || "Dashboard");
    }, [location.pathname]);

    const handleSetActivePage = (page: string) => {
        // setActivePage(page);
        navigate(`/layout/${page}`);
    };

    return (
        <Box sx={{ display: "flex", height: "100vh" }}>
            <CssBaseline />
            <Sidebar
                isOpen={isSidebarOpen}
                activePage={activePage}
                setActivePage={handleSetActivePage}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    width: {
                        xs: "100%",
                        sm: "calc(97% - 240px)",
                        marginTop: "55px"
                    }
                }}
            >
                <ContentSection
                    activePage={activePage}
                    setActivePage={handleSetActivePage}
                    updateIsReadStatus={updateIsReadStatus}
                    setUpdateIsReadStatus={setUpdateIsReadStatus}
                />
            </Box>
        </Box>
    );
};

export default Layout;
